import "./Select.scss";

function Select({options, value, onChange, placeholder = "Select an option", className = ""}) {
    return (
        <select className={`select-component ${className}`} value={value} onChange={onChange}>
            <option value="">{placeholder}</option>
            {options.map(function (option) {
                return (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                );
            })}
        </select>
    );
}

export {Select};
